export const FETCH_WORKSPACE_BY_ID = 'fetchWorkspaceById';
export const FETCH_USER_WORKSPACES = 'fetchUserWorkspaces';
export const UPDATE_WORKSPACE_BY_ID = 'updateWorkspace';
export const CREATE_WORKSPACE = 'createWorkspace';
